import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './i18n/config';

const enableMocking = async () => {
  if (!import.meta.env.DEV) {
    return;
  }
  const { worker } = await import('./mocks/browser');
  return worker.start({
    onUnhandledRequest: 'bypass',
  });
};

if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_ENV_TYPE) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: `${import.meta.env.VITE_ENV_TYPE}-v2`,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1,
  });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
